import {Component, Input} from '@angular/core';
import {NgClass} from "@angular/common";

@Component({
  selector: 'app-nav-button',
  imports: [
    NgClass
  ],
  templateUrl: './nav-button.component.html',
  styleUrl: './nav-button.component.css'
})
export class NavButtonComponent {
  @Input() buttonText: string = ''
  @Input() icon: string = ''
  @Input() buttonClass: string = 'btn-navigation'
  @Input() useSpinner: boolean = true
  @Input() loading: boolean = false
  @Input() disabled: boolean = false
  @Input() active: boolean = false
  @Input() alwaysShowText: boolean = false
}
